// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Scatter */\n.axis path,\n.axis line {\n  fill: none;\n  shape-rendering: crispEdges;\n  stroke: #b3b3b3;\n}\n\n.axis text {\n  font-size: 10px;\n  fill: #6b6b6b;\n}\n\n.dots .dot {\n  opacity: 0.7;\n}\n\n.dots.focused .dot {\n  opacity: 0.1;\n}\n\n.dots.focused .dot.focused {\n  opacity: 0.7;\n}\n\n.scatter-tooltip {\n  position: absolute;\n  pointer-events: none;\n  padding: 10px;\n  background: #eeeeee;\n  border-radius: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
